import { type ReactNode } from "react";
import { usePresignedUrl } from "@/features/documents";

interface PresignedUrlProviderProps {
    fileName: string;
    children: ({
        url,
        isLoading,
        error,
    }: {
        url: string | null;
        isLoading: boolean;
        error: Error | null;
    }) => ReactNode;
    bufferTime?: number; // Time in seconds before expiry to refresh
}

export function PresignedUrlProvider({
    fileName,
    children,
    bufferTime = 300, // Default 5 minutes buffer
}: PresignedUrlProviderProps) {
    // Use the React Query hook to fetch and cache the presigned URL
    const { data, isLoading, error } = usePresignedUrl(fileName, bufferTime);

    // Render function that passes URL to children
    return (
        <>
            {children({
                url: data?.url || null,
                isLoading,
                error: error
                    ? error instanceof Error
                        ? error
                        : new Error(String(error))
                    : null,
            })}
        </>
    );
}
